import { Search as SearchIcon } from '@mui/icons-material';
import { InputAdornment, TextField } from '@mui/material';
import React from 'react';

interface VideoLibrarySearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  /** Fill the container instead of the compact sidebar width. */
  fullWidth?: boolean;
}

/** Search-by-title field for the Video Library panel. */
export default function VideoLibrarySearchField({
  value,
  onChange,
  fullWidth = false,
}: VideoLibrarySearchFieldProps) {
  return (
    <TextField
      size="small"
      placeholder="Search by title…"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      fullWidth={fullWidth}
      sx={fullWidth ? undefined : { maxWidth: 320 }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" />
          </InputAdornment>
        ),
      }}
    />
  );
}
